import React from 'react';
import PropTypes from 'prop-types';
import {Card, CardBody} from 'components/card';

const ManageCardTouchPoints = ({manageBooking}) => {
  const {
    manage_booking_title, manage_booking_header, manage_booking_data, manage_booking_link
  } = manageBooking;

  return (
    <Card shadow>
      <CardBody>
        <div className="text-accent text-mini mb-2 font-bold text-uppercase">{manage_booking_title}</div>
        <div className="font-bold">{manage_booking_header}</div>
        <div className="mini-rectangle-line my-3 bg-primary" />
        {manage_booking_data.map(({title, text}, index) => (
          <div className="my-2" key={index}>
            <div className="font-bold">
              {title}
            </div>
            <div className="text-muted">
              {text}
            </div>
          </div>
        ))}
        <div>
          <a href={manage_booking_link}
            className="text-secondary" target="_blank" rel="noreferrer">
            {manage_booking_header}
          </a>
        </div>
      </CardBody>
    </Card>
  );
};

ManageCardTouchPoints.propTypes = {
  manageBooking: PropTypes.shape({
    manage_booking_title: PropTypes.string.isRequired,
    manage_booking_header: PropTypes.string.isRequired,
    manage_booking_data: PropTypes.array.isRequired,
    manage_booking_link: PropTypes.string.isRequired
  })
};

export default ManageCardTouchPoints;
